import React, { useEffect } from "react";
import Login from "../components/Login";
import Registration from "../components/Registration";
import { Tab, Tabs } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

function SigningPage() {
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Redirect if user is already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      // Redirect to the page they were trying to access or dashboard
      const from = location.state?.from || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);
  
  return (
    <div className="col-md-12" style={{ height: "100vh" }}>
      <Tabs defaultActiveKey="login" id="signing-tabs">
        <Tab eventKey="login" title="Login">
          <div>
            
            <div>
              <Login />
            </div>
          </div>
        </Tab>
        <Tab eventKey="registration" title="Registration">
          <div>
           
            <div>
              <Registration />
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}

export default SigningPage;
